import axiosInstance from './axiosInstance';

/**
 * Uploads a photo to the server.
 *
 * @param data - The FormData containing the photo file and other relevant information.
 * @returns A promise that resolves with the response from the server, or rejects with an error if the upload fails.
 */
export const uploadPhoto = (data: FormData) =>
  axiosInstance.post('/photos', data);
